import { Results, usePagination, useResults } from "@usereactify/search";
import React, { useEffect, useState } from "react";
import { ProductCard } from "./ProductCard";
import { Callout } from "./Callout";
import { PaginationNumbered } from "../pagination/PaginationNumbered";
import { PaginationPrevNext } from "../pagination/PaginationPrevNext";
import { attachBIS } from "@app/scripts/swym";

export const ResultsList: React.FC = () => {
  const results = useResults();
  const standardPerPage = 18;
  const [firstLoad, setFirstLoad] = useState(true);

  // attach swym notify me whenever the results are changed
  useEffect(() => {
    if (typeof results?.resultStats?.currentPage === "number") {
      attachBIS();
    }
  }, [results?.resultStats?.currentPage]);

  useEffect(() => {
    // remove liquid skeleton elements
    document.querySelector("[data-search-skeleton]")?.remove();
  }, []);

  useEffect(() => {
    if (results?.loading) {
      setFirstLoad(true);
    }
  }, [results?.loading]);

  const shouldDisplaySkeleton = firstLoad && results?.loading

  return (
    <>
      <div className={shouldDisplaySkeleton ? "" : "hidden"}>
        <ResultsListSkeleton standardPerPage={standardPerPage} />
      </div>
      <div className={shouldDisplaySkeleton ? "hidden" : ""} data-search-grid>
        <Results
          listClassName={`search__results-grid`}
          listStyle={{}}
          renderResultCardProduct={ProductCard}
          renderResultCardCallout={Callout}
          renderPaginationNumbered={PaginationNumbered}
          renderPaginationNextPrev={PaginationPrevNext}
        />
      </div>
    </>
  );
};

const ResultsListSkeleton: React.FC<{ standardPerPage: number }> = ({ standardPerPage }) => (
  <>
    <div className="search__results-skeleton-top react" />
    <div className="search__results-grid">
      {Array.apply(null, Array(standardPerPage)).map((_, i) => (
        <div className="rs__result-card-product skeleton-card" key={`skeleton${i}`}>
          <div className="rs__result-card-product__link">
            <div className="rs__result-card-product__image" />
            <span className="rs__result-card-product__vendor"></span>
            <span className="rs__result-card-product__title"></span>
          </div>
          <div className="rs__result-card-product__colours" />
          <div className="rs__result-card-product__prices" />
          <div className="rs__result-card-product__cta" />
        </div>
      ))}
    </div>
    <div className="search__results-skeleton-bottom" />
  </>
);
